// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import VueHead from 'vue-head';
import BootstrapVue from 'bootstrap-vue';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueScrollTo from 'vue-scrollto';
import Vuelidate from 'vuelidate';
import VueOnToast from 'vue-on-toast';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-resize/dist/vue-resize.css';
import VueResize from 'vue-resize';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import VueMq from 'vue-mq';
import ReactiveProvide from 'vue-reactive-provide';
import Vue2TouchEvents from 'vue2-touch-events';

import App from './App.vue';
import router from './router';
import store from './store/store';
// our styling
import './assets/css/style.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import 'vue-on-toast/dist/vue-on-toast.css';
import './assets/css/main.css';
import Container from '@/dependency_injection/container';
import injectCommonComponents from './dependency_injection/injectCommonComponents';
import mediaQueries from './components/common/mixins/mediaQueries';
import commonData from './components/common/mixins/commonData';
import './lib/icons';
import './lib/globalEvents';
import Api from '@/service/api';

Vue.prototype.$api = new Api(store);

Vue.use(BootstrapVue);
Vue.use(VueHead);
Vue.use(VueScrollTo);
Vue.use(Vuelidate);
Vue.use(VueFormWizard);
Vue.use(VueResize);
Vue.use(Vue2TouchEvents);
Vue.use(VCalendar, {
  firstDayOfWeek: 1, // Monday
  popoverVisibility: 'focus',
});
Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity,
  },
  defaultBreakpoint: 'sm',
});
Vue.use(VueOnToast);
Vue.use(ReactiveProvide, {
  name: 'provideReactive',
});

Vue.component('App', App);

Vue.config.productionTip = false;
// Vue.config.performance = process.env.NODE_ENV !== 'production';

Vue.mixin(mediaQueries);
Vue.mixin(commonData);

const container = new Container(!['local', 'development', 'dev-local'].includes(process.env.NODE_ENV));
// Inject the container into vuex and the router.
store.$container = container;
/* expose store and router during tests */
if (window.Cypress) {
  window.store = store;
  window.router = router;
}

/*
 * KLUDGE: The very first time beforeEach is fired after a page refresh, router.app.$container
 * is uninitialized. As a workaround I've manually set it here and if router.app is not
 * initialized I fall back to using this one. Would love a better solution if you have one.
 */
router.$container = container;

injectCommonComponents();

if (store.getters.isCoach) {
  router.push({
    name: 'teamOverview',
  });
}

store.dispatch('initialize')
  .then(() => {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      container,
      template: '<App/>',
      render: h => h(App),
    }).$mount('#app');
  });
